import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Dil dosyalarını import ediyoruz
import translationEN from './locales/en.json';
import translationTR from './locales/tr.json';

export const LANGUAGE_STORAGE_KEY = 'i18nextLng';
const SUPPORTED = ['tr', 'en'];

// 'en-US', 'EN', 'tr-TR' gibi değerleri desteklenen iki koda indirger; bilinmeyen → null
export const normalizeLanguage = (value) => {
  const code = String(value || '').trim().slice(0, 2).toLowerCase();
  return SUPPORTED.includes(code) ? code : null;
};

// Gizli sekme / engellenmiş site verisinde localStorage erişimi hata fırlatabilir: uygulama çökmesin
const readSaved = () => {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY);
  } catch {
    return null;
  }
};

const persist = (lng) => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  } catch {
    // depolama kapalı: tercih yalnızca bu oturumda geçerli
  }
};

// Kayıtlı dil (yoksa Türkçe); eski sürümlerin bıraktığı 'en-US' gibi değerler de tanınır
const savedLanguage = normalizeLanguage(readSaved()) || 'tr';

const resources = {
  en: {
    translation: translationEN
  },
  tr: {
    translation: translationTR
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage, // Kaydedilmiş dili kullan
    fallbackLng: 'tr',
    supportedLngs: SUPPORTED,
    load: 'languageOnly',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Her dil değişiminde tercihi açıkça kaydet ve <html lang> güncelle (yenilemede seçim korunur)
const applyLanguage = (lng) => {
  const code = normalizeLanguage(lng) || 'tr';
  persist(code);
  if (typeof document !== 'undefined') document.documentElement.lang = code;
};
applyLanguage(i18n.language || savedLanguage);
i18n.on('languageChanged', applyLanguage);

export default i18n;
